<template>
  <b-container>
    <b-card
      v-if="renderPage"
      title="Link de Recorrência"
      align="center"
      class="card-content mt-2"
    >
      <b-row class="mb-4 column-change">
        <b-col md="12">
          <div class="align-self-center">
            <b-alert
              class="alert-size"
              :variant="res.link.status.variant"
              show
            >
              <div class="alert-body">
                <feather-icon
                  :icon="res.link.status.icon"
                  size="25"
                />
                <span> {{ res.link.status.status }}</span>
              </div>
            </b-alert>
          </div>
          <b-col
            md="12"
            xl="12"
          />

          <Receipt
            type="recurrence"
            :receipt-data="res"
          />
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import {
  BContainer,
  BCard,
  BAlert,
  BRow,
  BCol,
} from 'bootstrap-vue'

import Receipt from '@/layouts/components/Receipt.vue'

import { callLoading } from '@/service/utilities/utilities'
import { getLink } from '@/service/pay/pay'

export default {
  components: {
    BContainer,
    BCard,
    BAlert,
    BRow,
    BCol,
    Receipt,
  },
  data() {
    return {
      renderPage: false,
      res: {
        link: {
          status: {},
        },
        payment: {},
        product: {},
        customer: {},
        user: {},
      },
      Status: 'Approved',
      statusColor: 'sucess',
      statusType: {
        1: {
          status: 'Aprovado',
          variant: 'success',
          icon: 'CheckCircleIcon',
          code: 1,
        },
        2: {
          status: 'Não Autorizado',
          variant: 'danger',
          icon: 'XCircleIcon',
          code: 2,
        },
        3: {
          status: 'Revisão',
          variant: 'warning',
          icon: 'AlertCircleIcon',
          code: 3,
        },
        8: {
          status: 'Falha na Recorrência',
          variant: 'danger',
          icon: 'XCircleIcon',
          code: 8,
        },
        9: {
          status: 'Criado',
          variant: 'success',
          icon: 'CheckCircleIcon',
          code: 9,
        },
        11: {
          status: 'Aguardando Pagamento',
          variant: 'secondary',
          icon: 'ClockIcon',
          code: 11,
        },
        12: {
          status: 'Expirado',
          variant: 'warning',
          icon: 'XIcon',
          code: 12,
        },
        13: {
          status: 'Pix Pago',
          variant: 'success',
          icon: 'CheckCircleIcon',
          code: 13,
        },
      },
    }
  },
  async mounted() {
    callLoading(true)
    await this.searchRecurrence()
    this.res.link.status = this.statusType[this.res.link.status]
    this.renderPage = true
    callLoading(false)
  },
  methods: {
    async searchRecurrence() {
      const { hash } = this.$route.params

      try {
        const response = await getLink('recurrence-link', hash)
        if (response.status === 200) {
          const { status } = response.data.link
          if (status === 1 || status === 2 || status === 3) {
            this.res = response.data
          } else {
            this.$router.push(`/link-recorrencia/1/${hash}`)
            return
          }
        } else this.$router.push('/error404')
      } catch {
        this.$router.push('/error404')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  @import "@core/scss/vue/pages/page-payment-status";
</style>
